<template>
    <div class="topdiv">
        <p class="main_title">我的订单</p>
        <Table class="mytableframe"  row-key="id" :no-data-text="nodatatxt" :columns="table_header" :border="false" :data="table_data" :height="table_height">
            <template slot-scope="{ row }" slot="orderid">
                <strong>{{row.orderid}}</strong>
            </template>
            <template slot-scope="{ row }" slot="product_desc">
                <div>
                    <span>{{row.product_desc}}</span>
                </div>
            </template>
            <template slot-scope="{ row }" slot="actualamount">
                <div>
                    <span>{{ row.actualamount===0?'':row.actualamount }}</span>
                </div>
            </template>
            <template slot-scope="{ row }" slot="paytype">
                <div v-if="row.paytype >= 30 && row.paytype <40">
                    <span>微信</span>
                </div>
                <div v-else-if="row.paytype >= 20 && row.paytype <30">
                    <span>支付宝</span>
                </div>
                <div v-else-if="row.paytype===60">
                    <span>企服平台在线支付</span>
                </div>
                <div v-else-if="row.paytype===50">
                    <span>线下支付</span>
                </div>
            </template>
            <template slot-scope="{ row }" slot="ordertime">
                <div>
                    <span>{{ row.ordertime }}</span>
                </div>
            </template>
            <template slot-scope="{ row }" slot="action">
                <div v-if="row.paystatus===100" style="text-align: center;">
                    <!-- <Button type="text" size="small" style="box-shadow: none;"></Button> -->
                    <div style="color:#19be6b;">已完成</div>
                    <!--           <Button type="info" size="small" style="margin-left: 10px;" @click="getMyInvoice(row)">开票</Button> -->
                </div>
                <div v-else style="text-align: center;">
                    <!-- <Button type="text" size="small" style="box-shadow: none;"></Button> -->
                    <div>未支付</div>
                </div>
            </template>
        </Table>
        <Modal v-model="modalInvoice" width="600" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>开票</span>
            </p>
            <div style="text-align: left;">
                <Invoice ref="myinvoice" :isModal="true" />
            </div>
            <div slot="footer" style="text-align: center;">
                <!--  <Button type="primary"  style="width:120px;">关闭</Button> -->
                <Button type="primary" style="width:150px;" @click="sendInvoice">提交</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import MyInvoice from './myinvoice.vue'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            nodatatxt:"<img src='/resource/images/nodata.png' style='height:\'98px;\' width=\'66px;\'' />",
            modalInvoice: false,
            table_header: [{
                    title: '订单号',
                    key: 'orderid',
                    //width: 300,
                },
                {

                    title: '订单明细',
                    slot: 'product_desc',
                    width: 300,
                    tree: true
                },
                {
                    title: '交易金额',
                    slot: 'actualamount'
                },
                {

                    title: '支付平台',
                    slot: 'paytype',
                },
                {

                    title: '下单时间',
                    slot: 'ordertime',
                },

                // {
                //     title: '产品价格',
                //     key: 'total',
                //     render: (h, params) => {
                //         const row = params.row
                //         const text = Number(row.total).toFixed(2)
                //         //return h('span', text + " 元");
                //         return h('span', [
                //             h('span', {
                //                 domProps: {
                //                     innerHTML: `<span>` + text + `</span> 元 <br /> 促销`,
                //                 }
                //             }), ''
                //         ])
                //     }
                // },
                {
                    title: '操作',
                    slot: 'action',
                    width: 200,
                    align: 'center'
                }
            ],
            table_data: [
                // {
                //         orderid: 'a123ccss1asd',
                //         title: '全国版种子用户',
                //         amount: 365,
                //         paytype: '微信',
                //         orderstate:1,
                //         ordertime: '2020-09-09'
                //     },
                //     {
                //         orderid: 'a123ccss1asd',
                //         title: '全国版种子用户',
                //         amount: 365,
                //         paytype: '支付宝',
                //         orderstate:2,
                //         ordertime: '2021-09-09'
                //     },
            ],
            table_height:740 ,
        }
    },
    components: {
        'Invoice': MyInvoice,
    },
    computed: {

    },
    created() {
        console.log('my vip==========>')
        //console.log(this.$route.name)
        this.show()
        // let a = document.getElementsByClassName('main-right')[0]
        // this.table_height = a.clientHeight - 50
        //console.log(a.clientHeight)
    },
    methods: {
        sendInvoice() {
            this.$refs.myinvoice.takeInvoice()
        },
        show() {
            constJ.reqGetOrderList().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.items && res.items.length > 0) {
                        this.table_data = res.items
                    }

                }
            })
        },
        getMyInvoice(row) {
            console.log(row)
            this.modalInvoice = true
            this.$refs.myinvoice.formData.invoiceTotal = row.orderamount
            this.$refs.myinvoice.orderid = row.orderid
            //   this.$refs.myinvoice.invoicetype = row.invoicestatus.toString()
            this.$refs.myinvoice.getInvoice()


        },
    }
}
</script>
<style lang='less' scoped>
.topdiv{
    background:#fff;
    padding: 5px;
    width:98%;
    margin:0 auto;
}

.main_title{
height: 20px;
font-size: 20px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #2D2F33;
margin-bottom: 30px;
padding-left: 10px;
}

.mytableframe/deep/tr{
    height: 50px;
}
</style>